import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "footer";
var attributes = {
    LAYOUT_BREAKPOINT: 'layout-breakpoint',
    LAYOUT: 'layout'
};
var classes = {
    FOOTER: 'tyl-footer',
    ALTERNATIVE_LAYOUT: 'tyl-footer--alternative'
};
var selectors = {
    FOOTER: "." + classes.FOOTER,
};
var strings = {
    DEFAULT_LAYOUT: 'auto',
    ROLE: 'contentinfo'
};
var numbers = {
    LAYOUT_BREAKPOINT: 900,
};
export var FOOTER_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    selectors: selectors,
    strings: strings,
    numbers: numbers
};
